import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { EnterpriseState, Department } from './enterprise.types'

const initialState = {
  departments: [],
  selectedDepartment: null,
  isLoading: false,
  error: null,
  isDepartmentsLoaded: false,
}

export const useEnterpriseStore = create<EnterpriseState>()(
  devtools(
    (set, get) => ({
      ...initialState,

      setIsDepartmentsLoaded: (isDepartmentsLoaded: boolean) =>
        set({ isDepartmentsLoaded }, false, 'setIsDepartmentsLoaded'),

      setDepartments: (departments: Department[]) =>
        set(
          {
            isDepartmentsLoaded: true,
            departments,
            isLoading: false,
            error: null,
          },
          false,
          'setDepartments'
        ),

      setSelectedDepartment: (selectedDepartment: Department | null) =>
        set({ selectedDepartment }, false, 'setSelectedDepartment'),

      setLoading: (isLoading: boolean) =>
        set({ isLoading }, false, 'setLoading'),

      setError: (error: string | null) => set({ error }, false, 'setError'),

      clearDepartments: () =>
        set(
          {
            departments: [],
            selectedDepartment: null,
            error: null,
            isLoading: false,
          },
          false,
          'clearDepartments'
        ),

      reset: () => set(initialState, false, 'reset'),
    }),
    {
      name: 'enterprise-store',
    }
  )
)

export const useEnterpriseDepartments = () =>
  useEnterpriseStore((state) => state.departments)

export const useSelectedDepartment = () =>
  useEnterpriseStore((state) => state.selectedDepartment)

export const useEnterpriseLoading = () =>
  useEnterpriseStore((state) => state.isLoading)

export const useEnterpriseError = () =>
  useEnterpriseStore((state) => state.error)

export const useEnterpriseActions = () => {
  const store = useEnterpriseStore()
  return {
    setDepartments: store.setDepartments,
    setSelectedDepartment: store.setSelectedDepartment,
    setLoading: store.setLoading,
    setError: store.setError,
    clearDepartments: store.clearDepartments,
    reset: store.reset,
  }
}
